import { enforceCockpitDisplayContract } from "../utils/cockpit-display-contract";
import { http } from "@/core/api";
import type {
  CockpitData,
  CockpitDetails,
} from "../types/executive-cockpit.types";
export const executiveCockpitApi = {
  async overview(params: Record<string, unknown>, signal?: AbortSignal) {
    return enforceCockpitDisplayContract(
      (
        await http.get<{ data: CockpitData }>("/analytics/v1/cockpit", {
          params,
          signal,
        })
      ).data.data,
    );
  },
  async ranked(params: Record<string, unknown>, signal?: AbortSignal) {
    return enforceCockpitDisplayContract(
      (
        await http.get<{
          data: {
            meta: CockpitData["meta"];
            entity: string;
            sort: string;
            direction: string;
            rows: import("../types/executive-cockpit.types").CockpitRow[];
            top5: import("../types/executive-cockpit.types").CockpitRow[];
            total: number;
            page: number;
            per_page: number;
            totals: Record<
              string,
              Record<
                string,
                import("../types/executive-cockpit.types").CockpitMetric
              >
            >;
          };
        }>("/analytics/v1/cockpit/entities", { params, signal })
      ).data.data,
    );
  },
  async snapshot(snapshot_id: string, signal?: AbortSignal) {
    return enforceCockpitDisplayContract(
      (
        await http.get<{ data: CockpitData }>(
          "/analytics/v1/cockpit/snapshot",
          {
            params: { snapshot_id },
            signal,
          },
        )
      ).data.data,
    );
  },
  async details(params: Record<string, unknown>, signal?: AbortSignal) {
    return enforceCockpitDisplayContract(
      (
        await http.get<{ data: CockpitDetails }>(
          "/analytics/v1/cockpit/details",
          { params, signal },
        )
      ).data.data,
    );
  },
};
